import clsx from 'clsx'
import CloseIcon from '@ancon/wildcat-ui/shared/icons/close-x.svg'
import BackIcon from '@ancon/wildcat-ui/shared/icons/arrow-back.svg'
import OrderCharacterWaitingClock from '@ancon/wildcat-ui/shared/illustrations/order-character-waiting-clock.svg'
import OrderCharacterKitchenOutOfCapacity from '@ancon/wildcat-ui/shared/illustrations/order-character-kitchen-out-of-capacity.svg'

import HeadingText from '../../../app/components/HeadingText'
import { ModalHeaderProps } from '../../../app/components/modal/ModalHeader'
import useAppSelector from '../../../../store/hooks/useAppSelector'
import useAppDispatch from '../../../../store/hooks/useAppDispatch'
import {
  checkoutCapacityConflictActiveOptionSelector,
  checkoutCapacityConflictOptionsSelector,
  checkoutCapacityConflictSingleSelector,
} from '../../store/checkoutSelectors'
import { checkoutSetCapacityConflictSelectedOption } from '../../store/checkoutSlice'

import styles from './CapacityConflictModalHeader.module.scss'

export default function CapacityConflictModalHeader({
  title,
  onClose,
}: ModalHeaderProps) {
  const dispatch = useAppDispatch()

  const single = useAppSelector(checkoutCapacityConflictSingleSelector)
  const activeOption = useAppSelector(
    checkoutCapacityConflictActiveOptionSelector,
  )
  const options = useAppSelector(checkoutCapacityConflictOptionsSelector)

  const showBack = !single && activeOption != null
  const showCloseButton = !showBack && !!onClose

  function handleBack() {
    dispatch(checkoutSetCapacityConflictSelectedOption(null))
  }

  function renderIcon() {
    if (activeOption == null) {
      return options.length > 0 ? (
        <OrderCharacterKitchenOutOfCapacity className={styles.illustration} />
      ) : (
        <OrderCharacterWaitingClock className={styles.illustration} />
      )
    }

    return <OrderCharacterWaitingClock className={styles.illustration} />
  }

  return (
    <div className={styles.header}>
      {showBack && (
        <button
          type="button"
          className={clsx(styles.cornerButton, styles.cornerButtonLeft)}
          onClick={handleBack}
          aria-label="back"
        >
          <BackIcon className={styles.backIcon} />
        </button>
      )}
      {showCloseButton && (
        <button
          type="button"
          className={clsx(styles.cornerButton, styles.cornerButtonRight)}
          onClick={onClose}
          aria-label="close"
        >
          <CloseIcon className={styles.closeIcon} />
        </button>
      )}
      <div className={styles.headerCol}>
        {renderIcon()}
        <HeadingText as="h2" className={styles.title}>
          {title}
        </HeadingText>
      </div>
    </div>
  )
}
